/** Colores de calendario para ausencias (distintos de turnos laborables #2563eb) */
export const ABSENCE_CALENDAR_STYLES = {
  vacation: {
    label: 'Vacaciones',
    backgroundColor: '#f59e0b',
    borderColor: '#d97706',
    className: 'labor-fc-absence-vacation',
  },
  sick_leave: {
    label: 'Baja médica',
    backgroundColor: '#ef4444',
    borderColor: '#b91c1c',
    className: 'labor-fc-absence-sick',
  },
  maternity: {
    label: 'Maternidad / paternidad',
    backgroundColor: '#ec4899',
    borderColor: '#be185d',
    className: 'labor-fc-absence-maternity',
  },
  training: {
    label: 'Formación',
    backgroundColor: '#14b8a6',
    borderColor: '#0f766e',
    className: 'labor-fc-absence-training',
  },
  special_leave: {
    label: 'Permiso especial',
    backgroundColor: '#a855f7',
    borderColor: '#7e22ce',
    className: 'labor-fc-absence-special',
  },
  unpaid_leave: {
    label: 'Excedencia',
    backgroundColor: '#64748b',
    borderColor: '#475569',
    className: 'labor-fc-absence-unpaid',
  },
};

export const ABSENCE_CALENDAR_LEGEND = Object.entries(ABSENCE_CALENDAR_STYLES).map(
  ([type, style]) => ({ type, ...style })
);

export function getAbsenceCalendarStyle(absenceType) {
  return (
    ABSENCE_CALENDAR_STYLES[absenceType] || {
      label: 'Ausencia',
      backgroundColor: '#7c3aed',
      borderColor: '#5b21b6',
      className: 'labor-fc-absence-other',
    }
  );
}
